import { TWOFA } from "../actions/types"

export default function _(state = null, action) {
    switch(action.type) {
        case TWOFA:
            return action.payload
        default:
            return state
    }
}